// extracted by mini-css-extract-plugin
export default {"alert":"SmallAlert_alert__835Ug","span":"SmallAlert_span__IN+HS"};